<template>
  <div class="spec-container">
    <div class="d-flex  align-items-center">
      <span
        style="font-size: 16px;font-weight: 600;margin-right: 15px; color: #2B3447"
      >
        {{ $l('INDEX.evg_sku_tab_pane_label_SPEC') || '产品规格' }}
      </span>
      <el-divider
        direction="vertical"
        v-if="!disabledEdit && !specIsSingle"
      ></el-divider>
      <div v-if="!disabledEdit && !specIsSingle">
        <b-button
          size="sm"
          class="ml-2"
          variant="outline-success"
          @click="addSpec"
        >
          {{ $l('INDEX.evg_sku_label_add_spec') || '新增规格' }}
        </b-button>
      </div>
    </div>
    <div class="spec-list-info__container">
      <div v-for="(item, index) in specList" :key="item.id">
        <SpecInfo
          :v-model="item"
          :currIndex="index"
          :evgSkuCode="evgSkuCode"
          :specInfo="item"
          :disabled="disabled"
          :isFormal="isFormal"
          @delSpec="delSpec"
          @updateSpec="updateSpec"
          @editImage="editImage"
        ></SpecInfo>
      </div>
      <div v-if="isEmpty" class="no-data__wrapper">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
          </p>
        </div>
      </div>
    </div>
    <EditSpecInfo
      v-if="editSpecInfo.specInfoVisible"
      :visible.sync="editSpecInfo.specInfoVisible"
      :title="editSpecInfo.title"
      :disabled="disabledEdit"
      @reload="initSpec"
      :evgSkuCode="evgSkuCode"
      :evgSkuSpecCode="editSpecInfo.evgSkuSpecCode"
    ></EditSpecInfo>

    <EditImage
      :visible.sync="editImageOpts.visible"
      :evgSkuCode="editImageOpts.evgSkuCode"
      :evgSkuSpecCode="editImageOpts.evgSkuSpecCode"
      @reload="initSpec"
    />
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import SpecInfo from './spec-info'
import EditSpecInfo from './edit-spec-info'
import EditImage from './edit-image'
export default {
  components: { SpecInfo, EditSpecInfo, EditImage },
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: true },
    isFormal: { type: Boolean, default: false },
    isSingle: { type: Boolean, default: true },
    evgSkuCode: { type: String, default: '' },
  },
  data() {
    return {
      specList: [],
      editSpecInfo: {
        specInfoVisible: false,
        evgSkuSpecCode: '',
        title: '',
      },
      editImageOpts: { visible: false, evgSkuCode: '', evgSkuSpecCode: '' },
    }
  },
  computed: {
    isEmpty() {
      return !this.specList.length
    },
    specIsSingle() {
      return this.specList.length == 1 && this.isSingle
    },
    disabledEdit() {
      return this.disabled || this.isFormal
    },
  },
  mounted() {
    this.initSpec()
  },
  methods: {
    initSpec() {
      if (!this.evgSkuCode) return
      this.$api
        .ecomEvgSkuSpecListApi({
          evgSkuCode: this.evgSkuCode,
        })
        .then((res) => {
          this.specList = res.body.data
        })
      this.$emit('reload')
    },
    addSpec() {
      this.editSpecInfo = {
        specInfoVisible: true,
        evgSkuSpecCode: '',
        title: this.$l('INDEX.evg_sku_label_add_spec_info') || '新增规格信息',
      }
    },
    updateSpec({ evgSkuSpecCode }) {
      this.editSpecInfo = {
        specInfoVisible: true,
        evgSkuSpecCode: evgSkuSpecCode,
        title: this.$l('INDEX.evg_sku_label_edit_spec_info') || '编辑规格信息',
      }
    },
    delSpec({ evgSkuSpecCode }) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.loadingOpen()
        this.$api
          .ecomEvgSkuSpecDelApi({
            evgSkuSpecCode,
          })
          .then(() => {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.loadingClose()
            this.initSpec()
          })
          .catch(() => {
            this.loadingClose()
          })
      })
    },
    editImage({ evgSkuSpecCode, evgSkuCode }) {
      this.editImageOpts = { visible: true, evgSkuSpecCode, evgSkuCode }
    },
  },
}
</script>
<style lang="scss" scoped>
.no-data__wrapper {
  height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
